import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { generateUniqId } from 'helpers/commonHelpers';
import { FormValuesModel, ServiceProviderFormItem } from '.';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';

// components
import SubmitButtons from '../SubmitButtons';
import HideIfDisabledForm from 'components/Forms/HideIfDisabledForm';
import ServiceProviderForm from './ServiceProviderForm';
import { Button, Col, Divider, Row } from '@ui';

const InnerForm = () => {
  const { t } = useTranslation('onboarding');
  const { values, setFieldValue } = useFormikContext<FormValuesModel>();

  const renderServiceProviders = (helpers: FieldArrayRenderProps) => {
    const canRemoveAddress = !values.requiredServiceProviders.length
      ? values.serviceProviders.length > 1
      : true;

    return values.serviceProviders.map((e, i) => (
      <Col key={e.id} span={24}>
        <ServiceProviderForm
          index={values.requiredServiceProviders.length + i}
          fieldName={`serviceProviders.${i}`}
          deleteCallback={
            canRemoveAddress ? () => helpers.remove(i) : undefined
          }
        />
      </Col>
    ));
  };

  const addServiceProvider = () => {
    const newServiceProviders: ServiceProviderFormItem[] = [
      ...values.serviceProviders,
      {
        id: `custom-${generateUniqId()}`,
        serviceProvider: null,
        description: '',
        additionalFields: [],
      },
    ];
    setFieldValue('serviceProviders', newServiceProviders);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        {values.requiredServiceProviders.map((e, i) => (
          <Col key={e.id} span={24}>
            <ServiceProviderForm
              isMandatoryProvider
              index={i}
              fieldName={`requiredServiceProviders.${i}`}
            />
          </Col>
        ))}
        <FieldArray name="serviceProviders" render={renderServiceProviders} />
      </Row>
      <HideIfDisabledForm hideIfSubmitting>
        <StyledButton size="large" onClick={addServiceProvider}>
          {t('intake_form.service_providers.add_provider')}
        </StyledButton>
      </HideIfDisabledForm>
      <HideIfDisabledForm>
        <Divider />
        <SubmitButtons />
      </HideIfDisabledForm>
    </>
  );
};

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.marginSm};
`;

export default InnerForm;
